import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

import { hasPermission } from "@/modules/auth/lib/permissions";
import { RepairsListPage } from "@/modules/repairs/pages/RepairsList.page";

const repairsListSearchSchema = z.object({
	page: z.coerce.number().int().min(1).optional().default(1),
	limit: z.coerce.number().int().min(1).optional().default(25),
	query: z.string().optional(),
	client: z.string().optional().nullable(),
	clientName: z.string().optional(),
	technician: z.string().optional().nullable(),
	states: z.string().optional(),
	rejectQuotation: z.string().optional(),
	startDate: z.string().optional(),
	endDate: z.string().optional(),
});

export const Route = createFileRoute("/__authed/m/repairs/")({
	validateSearch: (search) => repairsListSearchSchema.parse(search),
	beforeLoad({ context }) {
		const user = "user" in context ? context.user : undefined;

		if (!hasPermission(user, "see_repairs")) {
			throw redirect({ to: "/m/dashboard" });
		}
	},
	component: RouteComponent,
});

function RouteComponent() {
	const search = Route.useSearch();
	const navigate = Route.useNavigate();

	return (
		<RepairsListPage
			search={search}
			onSearchChange={(nextSearch, options) => {
				navigate({
					replace: options?.replace,
					search: (previousSearch) => ({ ...previousSearch, ...nextSearch }),
				});
			}}
		/>
	);
}
